import { Client, cacheExchange, fetchExchange } from 'urql';
import { graphqlAPI } from './constants';
import keycloak from './keycloak-client';

export const graphqlClient = new Client({
  url: graphqlAPI,
  exchanges: [cacheExchange, fetchExchange],
  fetchOptions: () => {
    // Safely attempt to refresh token before each request
    if (keycloak.authenticated) {
      try {
        keycloak.updateToken(30); // Refresh if expires within 30 seconds
      } catch (error) {
        console.warn(
          'Token refresh failed, proceeding with existing token:',
          error,
        );
      }
    }

    return {
      headers: {
        authorization: keycloak.authenticated ? `Bearer ${keycloak.token}` : '',
        'Content-Type': 'application/json',
      },
    };
  },
});
